module.exports = __webpack_public_path__ + "img/slika56.9def2fd6.jpg";